import React from 'react';
import { useTenantBranding } from '@/context/TenantBranding';

// LegitScript seals, LegitScript's markup verbatim. Each certified tenant has
// its own seal for its own domain; everyone else shows Fitpal's.
const LEGITSCRIPT_SEALS = {
  fitpal: { domain: 'fitpal.com', sealId: '17884731' },
  dexaslim: { domain: 'dexaslim.com', sealId: '47250630' }, // owner request 2026-11-03
};

export function legitScriptSealFor(tenantSlug) {
  return LEGITSCRIPT_SEALS[tenantSlug] || LEGITSCRIPT_SEALS.fitpal;
}

const Footer = () => {
  const { tenantSlug, ready } = useTenantBranding();
  const seal = legitScriptSealFor(tenantSlug);
  return (
    <footer className="w-full py-6 px-4 border-t border-gray-100">
      <div className="max-w-4xl mx-auto">
        {/* Trust indicators */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-4">
          <p className="text-sm text-gray-500">
            © 2026 Fitpal. All rights reserved. &nbsp;Powered by Fitpal Pro
          </p>
          
          {/* Rating badge */}
          <div className="flex items-center gap-3">
            <div className="trust-badge">
              <span className="text-sm font-semibold text-[#00b67a]">Excellent 4.8</span>
              <div className="flex gap-0.5 ml-1">
                {[1, 2, 3, 4, 5].map((star) => (
                  <svg key={star} className="w-4 h-4 star" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
            </div>
            <span className="text-sm text-gray-500">•</span>
            <span className="text-sm text-[#2d8a5f] font-medium">50,000+ happy customers</span>
          </div>
        </div>

        {/* Links */}
        <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-gray-500">
          <a href="#" className="hover:text-gray-700 transition-colors">Support Center</a>
          <span>•</span>
          <a href="#" className="hover:text-gray-700 transition-colors">Privacy Policy</a>
          <span>•</span>
          <a href="#" className="hover:text-gray-700 transition-colors">Terms of Service</a>
        </div>

        {/* LegitScript certification seal (owner request 2026-10-09; per-tenant
            2026-11-03). The seal image is served from LegitScript's CDN and the
            link opens their checker for the tenant's domain in a new tab. Held
            back until the tenant config resolves, so a DexaSlim link never
            flashes Fitpal's seal. */}
        {ready && (
          <div className="flex justify-center mt-4" data-testid="legitscript-seal">
            <a
              href={`https://www.legitscript.com/websites/?checker_keywords=${seal.domain}`}
              target="_blank"
              rel="noopener noreferrer"
              title={`Verify LegitScript Approval for www.${seal.domain}`}
            >
              <img
                src={`https://static.legitscript.com/seals/${seal.sealId}.png`}
                alt={`Verify Approval for www.${seal.domain}`}
                width="73"
                height="79"
                loading="lazy"
              />
            </a>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
